import { CertificateValidationResults } from 'App/types';

export const STORE_DFSP_CA = 'DFSP CA / Store';
export const SUBMIT_DFSP_CA = 'DFSP CA / Submit';
export const RESET_DFSP_CA = 'DFSP CA / Reset';
export const REQUEST_DFSP_CA = 'DFSP CA /  Request';
export const SET_DFSP_CA_ERROR = 'DFSP CA / Set Root Cert Error';
export const SET_DFSP_CA_ROOT_CERTIFICATE = 'DFSP CA / Set Root Certificate';
export const CHANGE_DFSP_CA_ROOT_CERTIFICATE = 'DFSP CA / Change Root Certificate';
export const SHOW_DFSP_CA_ROOT_CERTIFICATE_MODAL = 'DFSP CA / Show Root Certificate Modal';
export const HIDE_DFSP_CA_ROOT_CERTIFICATE_MODAL = 'DFSP CA / Hide Root Certificate Modal';
export const DOWNLOAD_DFSP_CA_ROOT_CERTIFICATE = 'DFSP CA / Download Root Certificate';
export const CHANGE_AND_SUBMIT_DFSP_CA_ROOT_CERTIFICATE =
  'DFSP CA / Change and Submit Root Certificate';
export const SET_DFSP_CA_INTERMEDIATE_CHAIN = 'DFSP CA / Set Intermediate Chain';
export const CHANGE_DFSP_CA_INTERMEDIATE_CHAIN = 'DFSP CA / Change Intermediate Chain';
export const SHOW_DFSP_CA_INTERMEDIATE_CHAIN_MODAL = 'DFSP CA / Show Intermediate Chain Modal';
export const HIDE_DFSP_CA_INTERMEDIATE_CHAIN_MODAL = 'DFSP CA / Hide Intermediate Chain Modal';
export const DOWNLOAD_DFSP_CA_INTERMEDIATE_CHAIN = 'DFSP CA / Download Intermediate Chain';
export const CHANGE_AND_SUBMIT_DFSP_CA_INTERMEDIATE_CHAIN =
  'DFSP CA / Change and Submit Intermediate Chain';
export const SET_DFSP_CA_VALIDATIONS = 'DFSP CA / Set Validations';
export const SET_DFSP_CA_VALIDATION_STATE = 'DFSP CA / Set Validation State';
export const SET_AUTO_GENERATE_DFSP_CA_CERTIFICATE = 'DFSP CA / Auto Generate';
export const REQUEST_DFSP_CA_HUB_CERTIFICATE = 'DFSP CA /  Request Hub Certificate';
export const SET_DFSP_CA_HUB_CERTIFICATE = 'DFSP CA /  Set Hub Certificate';
export const SET_DFSP_CA_HUB_CERTIFICATE_ERROR = 'DFSP CA /  Set Hub Certificate Error';
export const CHANGE_DFSP_CA_HUB_CERTIFICATE = 'DFSP CA / Change Hub Certificate';
export const SHOW_DFSP_CA_HUB_CERTIFICATE_MODAL = 'DFSP CA / Show Hub Certificate Modal';
export const HIDE_DFSP_CA_HUB_CERTIFICATE_MODAL = 'DFSP CA / Hide Hub Certificate Modal';
export const DOWNLOAD_DFSP_CA_HUB_CERTIFICATE = 'DFSP CA / Download Hub Certificate';

export interface DFSPCertificateAuthorityPayload {
  payload: string | undefined;
}

export interface SubmitDFSPCAAction {
  type: typeof SUBMIT_DFSP_CA;
  payload: DFSPCertificateAuthorityPayload;
}

export interface ChangeCertificateAction {
  type: typeof SUBMIT_DFSP_CA;
  payload: DFSPCertificateAuthorityPayload;
}

export interface ResetDFPCAAction {
  type: typeof RESET_DFSP_CA;
}

export interface RequestDFPCAAction {
  type: typeof REQUEST_DFSP_CA;
}

export interface SetDFSPCAErrorAction {
  type: typeof SET_DFSP_CA_ERROR;
  error: string;
}

export interface SetDFSPCARootCertificateAction {
  type: typeof SET_DFSP_CA_ROOT_CERTIFICATE;
  certificate: string;
}

export interface SetDFSPCAIntermediateChainAction {
  type: typeof SET_DFSP_CA_INTERMEDIATE_CHAIN;
  certificate: string;
}

export interface SetDFSPCAValidationsAction {
  type: typeof SET_DFSP_CA_VALIDATIONS;
  validations: CertificateValidationResults[];
}

export interface SetDFSPCAValidationsStateAction {
  type: typeof SET_DFSP_CA_VALIDATION_STATE;
  validationState: string | undefined;
}

export interface ChangeDFSPCARootCertificateAction {
  type: typeof CHANGE_DFSP_CA_ROOT_CERTIFICATE;
  certificate: string;
}

export interface ChangeDFSPCARootIntermediateChainAction {
  type: typeof CHANGE_DFSP_CA_INTERMEDIATE_CHAIN;
  certificate: string;
}

export interface ShowDFSPCARootCertificateModalAction {
  type: typeof SHOW_DFSP_CA_ROOT_CERTIFICATE_MODAL;
}

export interface HideDFSPCARootCertificateModalAction {
  type: typeof HIDE_DFSP_CA_ROOT_CERTIFICATE_MODAL;
}

export interface DownloadDFSPCARootCertificateAction {
  type: typeof DOWNLOAD_DFSP_CA_ROOT_CERTIFICATE;
}

export interface ShowDFSPCAIntermediateChainModalAction {
  type: typeof SHOW_DFSP_CA_INTERMEDIATE_CHAIN_MODAL;
}

export interface HideDFSPCAIntermediateChainModalAction {
  type: typeof HIDE_DFSP_CA_INTERMEDIATE_CHAIN_MODAL;
}

export interface DownloadDFSPCAIntermediateChainAction {
  type: typeof DOWNLOAD_DFSP_CA_INTERMEDIATE_CHAIN;
}

export interface ChangeAndSubmitDFSPCARootCertificateAction {
  type: typeof CHANGE_AND_SUBMIT_DFSP_CA_ROOT_CERTIFICATE;
  certificate: string;
}

export interface ChangeAndSubmitDFSPCARootIntermediateChainAction {
  type: typeof CHANGE_AND_SUBMIT_DFSP_CA_INTERMEDIATE_CHAIN;
  certificate: string;
}

export interface AutoGenerateDFSPCACertificateAction {
  type: typeof SET_AUTO_GENERATE_DFSP_CA_CERTIFICATE;
  certificate: string;
}

export interface SetDFSPCAHubCertificateAction {
  type: typeof SET_DFSP_CA_HUB_CERTIFICATE;
  certificate: string;
}

export interface SetDFSPCAHubCertificateErrorAction {
  type: typeof SET_DFSP_CA_HUB_CERTIFICATE_ERROR;
  error: string;
}

export interface RequestDFSPCAHubCertificateModalAction {
  type: typeof REQUEST_DFSP_CA_HUB_CERTIFICATE;
}

export interface ShowDFSPCAHubCertificateModalAction {
  type: typeof SHOW_DFSP_CA_HUB_CERTIFICATE_MODAL;
}

export interface HideDFSPCAHubCertificateModalAction {
  type: typeof HIDE_DFSP_CA_HUB_CERTIFICATE_MODAL;
}

export interface DownloadDFSPCAHubCertificateAction {
  type: typeof DOWNLOAD_DFSP_CA_HUB_CERTIFICATE;
}

export type DFSPCertificateAuthorityActionTypes =
  | ResetDFPCAAction
  | SetDFSPCAErrorAction
  | RequestDFPCAAction
  | SetDFSPCARootCertificateAction
  | SetDFSPCAIntermediateChainAction
  | SetDFSPCAValidationsAction
  | SetDFSPCAValidationsStateAction
  | ChangeDFSPCARootCertificateAction
  | ChangeDFSPCARootIntermediateChainAction
  | ShowDFSPCARootCertificateModalAction
  | HideDFSPCARootCertificateModalAction
  | ShowDFSPCAIntermediateChainModalAction
  | HideDFSPCAIntermediateChainModalAction
  | DownloadDFSPCARootCertificateAction
  | ChangeAndSubmitDFSPCARootCertificateAction
  | ChangeAndSubmitDFSPCARootIntermediateChainAction
  | AutoGenerateDFSPCACertificateAction
  | RequestDFSPCAHubCertificateModalAction
  | SetDFSPCAHubCertificateAction
  | SetDFSPCAHubCertificateErrorAction
  | ShowDFSPCAHubCertificateModalAction
  | HideDFSPCAHubCertificateModalAction
  | DownloadDFSPCAHubCertificateAction;

export interface DFSPCertificateAuthorityState {
  dfspName?: string;
  dfspCaError?: string;
  dfspCaRootCert?: string;
  dfspCaIntermediateChain?: string;
  dfspCaHubCert?: string;
  dfspCaValidations: CertificateValidationResults[];
  dfspCaValidationState?: string;
  isDfspCaRootCertificateModalVisible: boolean;
  isDfspCaIntermediateChainModalVisible: boolean;
  isDfspCaHubCertificateModalVisible: boolean;
}
